<template lang="pug">
  .login-ct
    EnvMarker
    .login-page(:style="{ backgroundImage: bg1 }")
      div
        .login-box
          .body
            img.login-logo(:src="logoImage", alt="Kezzler")
            slot
          .login-footer.field.small.text-center
            div
              | Copyright ©
              a(href="http://kezzler.com") Kezzler AS
              span.ml5 | Version {{ version }}
</template>

<script>
import bg from 'kezzler-app-design/src/assets/lines.svg'
import logoImage from 'kezzler-app-design/src/assets/kezzler-logo-blue.svg'
import EnvMarker from '@/components/ssp/EnvMarker'

export default {
  data: () => ({
    bg1: `url("${bg}")`,
    logoImage,
    version: process.env.PACKAGE_VERSION
  }),
  components: {
    EnvMarker
  }
}
</script>

<style lang="scss">
  *, *::after, *::before {
    box-sizing: border-box;
  }
  html, body {
    height: 100%;
    overflow-x: hidden;
  }

  .login-ct {
    height: 100%;
  }
  .login-ct .login-page input {
    color: black;
  }

  #login-modal {
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    z-index:9999;
    display:none;
  }

  .login-page {
    background:  fixed center #004FE1;
    background-repeat: no-repeat;
    color: #000;
    display: table;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-size: 17px;
    line-height: 1.6;
    > div {
      display: table-cell;
      vertical-align: middle;
      text-align: center;
    }
    .login-box {
      position: relative;
      z-index: 1;
      width: 450px;
      max-width: 100%;
      margin: auto;
      .body {
        padding: 40px 30px;
        text-align: left;
        background: #fff;
        border-radius: 5px;
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,.03);
      }
      .login-logo {
        display: block;
        margin-bottom: 30px;
        height: 22px;
      }
      .field {
        margin: 0;
        label: {
          display: block;
        }
        + .field {
          padding-top: 25px;
        }
      }
      input {
        border-radius: 3px;
        border: solid #c6c4d2 1px;
        padding: 10px 8px;
        font-family: 'MarkPro', Arial, sans-serif;
        font-size: 15px;
        &:-webkit-autofill {
          -webkit-box-shadow: none;
        }
        &[type=checkbox] {
          vertical-align: middle;
          margin: 0 5px 0 0;
        }
      }
      label {
        font-weight: 500;
      }
      label.bold {
        display: block;
        padding-bottom: 2px;
      }
      button {
        float: right;
        padding: 11px 26px;
        background: #004fe1;
        font-family: 'MarkPro', Arial, sans-serif;
        font-weight: 500;
        border: none;
        border-radius: 3px;
        font-size: 15px;
        padding: 8px 22px;
        color: #fff;
      }
      .login-footer {
        clear: both;
        padding-top: 27px;
        color: rgba(255,255,255,.7);
      }
      .btn-link-cancel {
        color: #000 !important;
      }
      a {
        color: rgba(255,255,255,.7) !important;
        text-decoration: none;
      }
    }
    .form-field {
      margin-top: 5px;
      width: 100%;
    }
    .text-center {
      text-align: center;
    }
    .small {
      font-size: 12px;
    }
  }

  @media (max-width : 480px) {
    .login-page {
      font-size: 15px;
      .login-box {
        width: 90%;
        .login-logo {
          height: 20px;
        }
        button {
          font-size: 14px;
        }
      }
    }
  }

  @media (min-width : 1080px) and (max-width: 1280px) {
    .login-page .login-box .body {
      padding: 50px 40px;
    }
  }

  @media (min-width : 1280px) {
    .login-page .login-box {
      width: 450px;
      .body {
        padding: 50px 40px;
      }
      .login-logo {
        height: 25px;
        margin-bottom: 35px;
      }
      button {
        font-size: 16px;
        padding: 9px 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ssp/LoginComponent.vue